<template>
  <div>
    <Breadcrumbs main="" title="firebase todo"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-header firebase-header">
              <h5>Item List (Firebase)</h5>
            </div>

            <div class="card-body custom-scrollbar">
              <div class="todo">
                <div class="todo-list-wrapper">
                  <div class="todo-list-container">                          

                    <div class="table-responsive datatable-vue m-0 vue-smart">
                      <v-table
                        :data="todolist" class="table"
                        :currentPage.sync="basic.currentPage"
                        :pageSize="10"
                        @totalPagesChanged="basic.totalPages = $event"
                      >
                        <thead slot="head">
                          <v-th sortKey="usage">Usage</v-th>
                          <v-th sortKey="type">Type</v-th>
                          <v-th sortKey="id">Item Id</v-th>
                          <v-th sortKey="name">Name</v-th>
                          <v-th sortKey="info">Info</v-th>
                          <v-th class="text-center" sortKey="state">Status</v-th>
                          <th class="text-center">Delete</th>
                        </thead>
                        <tbody slot="body" slot-scope="{displayData}">
                          <tr v-for="(todo, index) in displayData" :key="index" class="task"  :class="{'completed':todo.status == 'complete'}">
                            <td>
                              <b-badge v-if="todo.usage=='GIFT'" pill variant="success"><i class="icon-gift"></i> {{ todo.usage }}</b-badge>
                              <b-badge v-else pill variant="secondary"><i class="icon-shop"></i> {{ todo.usage }}</b-badge>
                            </td>
                            <td>
                              <b-badge v-if="todo.type=='PERMANENT'" pill variant="info">{{ todo.type }}</b-badge>
                              <b-badge v-else pill variant="success">{{ todo.type }}</b-badge>   
                            </td>
                            <td><b><i class="icon-tag"></i>{{ todo.itemId }}</b></td>
                            <td>{{ todo.name }}</td>
                            <td>{{ todo.info }}</td>
                            <td class="text-center">
                              <span @click="taskActive(todo.id,todo.status)" class="action-box large complete-btn" title="Mark Complete">
                                <b-badge v-if="todo.status=='INACTIVE'" pill variant="secondary"><i class="icon-check"></i>{{ todo.status }}</b-badge>
                                <b-badge v-else pill variant="success"><i class="icon-check"></i>{{ todo.status }}</b-badge>
                              </span>  
                            </td>
                            <td class="text-center">
                              <span class="task-action-btn">
                                <span @click="tododelete(todo.id)" class="action-box large delete-btn" title="Delete Task"><i class="icon"><i class="icon-trash"></i></i></span>
                              </span>                            
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                      <smart-pagination
                        :currentPage.sync="basic.currentPage"
                        :totalPages="basic.totalPages"
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <notifications classes="task" group="Todolist" />
                </div>
              </div>

              <!-- HTML Template for tasks-->
              <script id="task-template " type="tect/template">
                <li class="task">
                <div class="task-container">
                  <h4 class="task-label"></h4>
                  <span class="task-action-btn">
                    <span class="action-box large delete-btn" title="Delete Task">
                      <i class="icon"><i class="icon-trash"></i></i>
                    </span>
                    <span class="action-box large complete-btn" title="Mark Complete">
                      <i class="icon"><i class="icon-check"></i></i>
                    </span>
                  </span>
                </div>
                </li>
              </script>

            </div>
          </div>                
        </div>

        <div class="col-xl-12"> 
          <div class="default-according">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="div" role="tab" class="bg-primary">
                <h5 class="mb-0">
                  <b-button v-b-toggle.sectionItem><i class="fa fa-pencil-square"></i> Add new item <span class="digits"></span></b-button>
                </h5>
              </b-card-header>
              <b-collapse id="sectionItem" accordion="my-accordion" role="tabpanel">
                <b-card-body>

                  <div class="row">
                    <div class="col-sm-4">         
                      <div class="form-group m-form__group">
                        <b-input-group prepend="Usage" append="">
                          <b-input-group-prepend is-text><i class="fa fa-check-circle"></i></b-input-group-prepend>
                          <b-form-select v-model="item_usage" :options="usageOptions" id="item_usage" name="item_usage"></b-form-select>
                        </b-input-group>
                      </div>

                      <div class="form-group">
                        <b-input-group prepend="Type">
                          <b-input-group-prepend is-text><i class="fa fa-check-circle"></i></b-input-group-prepend>
                          <b-form-select v-model="item_type" :options="typeOptions" id="item_type" name="item_type"></b-form-select>
                        </b-input-group>
                      </div>                                                            
                    </div>
                    <div class="col-sm-4">       
                      <div class="form-group">
                        <b-input-group prepend="Item ID">
                          <b-input-group-prepend is-text><i class="fa fa-check-circle"></i></b-input-group-prepend>
                          <b-form-input v-model="item_id" type="numer" placeholder="0" id="item_id" name="item_id"></b-form-input>
                        </b-input-group>
                      </div>         
                      <div class="form-group">
                        <b-input-group prepend="Name">
                          <b-input-group-prepend is-text><i class="fa fa-check-circle"></i></b-input-group-prepend>
                          <b-form-input v-model="item_name" type="text" placeholder="" id="item_name" name="item_name"></b-form-input>
                        </b-input-group>
                      </div>                                                                       
                    </div>
                    <div class="col-sm-4">
                      <div class="form-group mb-0">                                          
                        <b-input-group prepend="Info">
                          <b-input-group-prepend is-text><i class="fa fa-check-circle"></i></b-input-group-prepend>
                          <b-form-textarea v-model="item_info" rows="3" id="item_info" name="item_info" placeholder="Enter new item info here. . ."></b-form-textarea>
                        </b-input-group>
                      </div>
                    </div>
                  </div>
                  <span @click="addnewtask()" class="btn btn-success ml-0 add-new-task-btn" id="add-task">Add Item</span>
                </b-card-body>
              </b-collapse>
            </b-card>                                                                    
          </div>
        </div>

        <div class="col-xl-12"> 
          <div class="default-according">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="div" role="tab" class="bg-secondary">
                <h5 class="mb-0">
                  <b-button v-b-toggle.sectionHowto><i class="fa fa-question-circle"></i> Howto <span class="digits"></span></b-button>
                </h5>
              </b-card-header>
              <b-collapse id="sectionHowto" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  1. 용도는 Gift용과 Shop전용으로 구분됩니다.<br>
                  2. Item ID는 '0' 이상의 숫자를 입력해주시기 바랍니다.<br>
                  3. Type의 일회용은 소비형이고, 영구성은 삭제 후에도 사용 가능합니다<br>
                  4. Name읜 Item의 이름을 입력해주세요.<br>
                  5. Info에는 간략하게 아이템에 대한 설명을 등록해 주세요.<br>
                  6. 삭제시 관련된 데이버에 영향을 줄수 있습니다.
                </b-card-body>
              </b-collapse>
            </b-card>                                                                    
          </div>
        </div>                          

      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import items from '../../data/items'

  export default {
    name:'todo',
    data(){
      return {
        markallread :true,
        addtask :false,
        task:'',
        item_name:'',
        item_info:'',
        items,
        basic:{
          currentPage: 1,
          totalPages: 0,
        },

        filter:{
          currentPage: 1,
          totalPages: 0,
        },

        idfilter:{
          currentPage: 1,
          totalPages: 0,
        },

        selectrow:{
          currentPage: 1,
          totalPages: 0,
        },

        selectedRows: [],        

        filters: {
            usage: { value: '', keys: ['usage'] },
            type: { value: '', keys: ['type'] },
            itemId: { value: '', keys: ['itemId'] },
            name: { value: '', keys: ['name'] },
            info: { value: '', keys: ['info'] },
            writedate: { value: '', keys: ['writedate'] },
            status: { value: '', keys: ['status'] },
        },

        usageOptions:[
            { value:'GIFT', text: 'Gift(선물 전용)'},
            { value:'SHOP', text: 'Shop(상점 전용)'}
        ],

        typeOptions:[
            { value:'DISPOSABLE', text: 'Disposable(일회용)'},
            { value:'PERMANENT', text: 'Permanent(영구 사용)'}
        ]          
      }
    },
    computed: {
      ...mapState({
        todolist: state => state.firebase_item.todo,
      }),
      formatted(){
        return Vue.filter('date')(this.value)
      }      
    },
    created(){
      this.retrieveTodos();
    },
    methods:{

      retrieveTodos()
      {
        this.$store.dispatch('firebase_item/retrieveTodos')
      },
      taskActive(id,status)
      {
        this.$store.dispatch('firebase_item/taskActive', id)
        this.retrieveTodos();

        if(status == "INACTIVE")
          this.$toasted.show("Item marked as ACTIVE.", {theme: 'outline', type: 'success', duration: 2000});
           else
          this.$toasted.show("Item marked as INACTIVE.", {theme: 'outline', type: 'error', duration: 2000});
      },
      tododelete(id)
      {
        if(status == "INACTIVE")
        {
          this.$store.dispatch('firebase_item/tododelete', id)
          this.retrieveTodos();
          this.$toasted.show("Item has been deleted.",{theme:'outline', type : 'success',duration:2000});
        }
        else
        {
          this.$toasted.show("Item is ACTIVE status, change to INACTIVE before delete.",{theme:'outline', type : 'error',duration:2000});
        }        
      },
      addnewtask()
      {
        if(this.item_name != '')
        {
          this.$store.dispatch('firebase_item/addtodo', this)

          this.item_name = ''
          this.item_info = ''
          this.addtask = false
          var container = this.$el.querySelector(".todo-list-body");
          setTimeout(function () {
            container.scrollBy({ top: 200, behavior: 'smooth' });
          }, 310)
          
          this.$toasted.show("Item list is updated.",{theme:'outline', type : 'success',duration:2000});
          this.retrieveTodos();
        }
      }
    }
  }
</script>
